"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.containsWhitelistedItems = exports.containsBlacklistedItems = exports.extractWhitelistedItems = exports.extractBlacklistedItems = exports.VALUES = exports.WHITELISTED_ITEMS = exports.BLACKLISTED_ITEMS = exports.HAS_WHITELISTED_ITEMS = exports.HAS_BLACKLISTED_ITEMS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _constants = require("settings-ui-sdk/DoiPages/constants");

var _selectors = require("settings-ui-sdk/DoiPages/selectors");

var HAS_BLACKLISTED_ITEMS = 'hasBlacklistedItems';
exports.HAS_BLACKLISTED_ITEMS = HAS_BLACKLISTED_ITEMS;
var HAS_WHITELISTED_ITEMS = 'hasWhitelistedItems';
exports.HAS_WHITELISTED_ITEMS = HAS_WHITELISTED_ITEMS;
var BLACKLISTED_ITEMS = 'blacklistedItems';
exports.BLACKLISTED_ITEMS = BLACKLISTED_ITEMS;
var WHITELISTED_ITEMS = 'whitelistedItems';
exports.WHITELISTED_ITEMS = WHITELISTED_ITEMS;
var VALUES = 'values';
exports.VALUES = VALUES;

var extractBlacklistedItems = function extractBlacklistedItems(pages) {
  return pages.filter(function (page) {
    return page.get(_constants.INCLUSION_STATE) === _constants.BLACKLIST;
  });
};

exports.extractBlacklistedItems = extractBlacklistedItems;

var extractWhitelistedItems = function extractWhitelistedItems(pages) {
  return pages.filter(function (page) {
    return page.get(_constants.INCLUSION_STATE) === _constants.WHITELIST;
  });
};

exports.extractWhitelistedItems = extractWhitelistedItems;

var containsBlacklistedItems = function containsBlacklistedItems(pages) {
  return pages && extractBlacklistedItems(pages).size > 0;
};

exports.containsBlacklistedItems = containsBlacklistedItems;

var containsWhitelistedItems = function containsWhitelistedItems(pages) {
  return pages && extractWhitelistedItems(pages).size > 0;
};

exports.containsWhitelistedItems = containsWhitelistedItems;
var properties = [HAS_BLACKLISTED_ITEMS, HAS_WHITELISTED_ITEMS, {
  type: _PropertyTypes.default.ORDERED_MAP,
  key: VALUES,
  initialValue: {}
}];

var _default = new _StagedObject.default({
  domainSelector: function domainSelector(state) {
    var _ref2;

    var pages = (0, _selectors.getDoiPages)(state);

    if (pages.size === 0) {
      var _ref;

      return new _immutable.Map((_ref = {}, (0, _defineProperty2.default)(_ref, HAS_BLACKLISTED_ITEMS, null), (0, _defineProperty2.default)(_ref, HAS_WHITELISTED_ITEMS, null), (0, _defineProperty2.default)(_ref, VALUES, pages), _ref));
    }

    return new _immutable.Map((_ref2 = {}, (0, _defineProperty2.default)(_ref2, HAS_BLACKLISTED_ITEMS, containsBlacklistedItems(pages)), (0, _defineProperty2.default)(_ref2, HAS_WHITELISTED_ITEMS, containsWhitelistedItems(pages)), (0, _defineProperty2.default)(_ref2, VALUES, pages), _ref2));
  },
  stagedSelector: function stagedSelector(state) {
    return state.modules.marketing.email.staging.updateDoiPages;
  },
  namespace: 'email',
  objectType: _constants.DOI_PAGES,
  properties: properties
});

exports.default = _default;